import type { StoryblokBlock, BlockTransformContext } from '~/lib/storyblok'
import type { GalleryBackBlock } from './types'

export async function transformGalleryBackBlock(
  block: StoryblokBlock,
  { props, options }: BlockTransformContext,
): Promise<GalleryBackBlock> {
  return {
    ...props,
    options,
  }
}
